import Layout from "../../components/Layout"
import { CampaignSummary, CampaignSummarySkeleton } from "@/components/CampaignSummary"
import { BROWSE_SKELETON_COLUMNS, TalentBrowse, TalentBrowseTable } from "@/components/talentBrowse"
import { useSkeletonPhases } from "@/hooks/useSkeletonPhases"
import { Navigate } from "react-router-dom"
import { eligibilityHasConstraints } from "../../utils/pitching/eligibility"
import { PitchCart } from "./components/PitchCart"
import { usePitching } from "./usePitching"

export default function Pitching() {
    const page = usePitching()
    const phase = useSkeletonPhases(page.loading)

    if (phase === "showSkeleton") {
        return (
            <Layout>
                <div className="min-w-0 flex-1 p-4">
                    <CampaignSummarySkeleton />
                    <TalentBrowseTable columns={BROWSE_SKELETON_COLUMNS} rows={[]} empty={null} isLoading />
                </div>
            </Layout>
        )
    }

    if (phase === "showNothing") {
        return (
            <Layout>
                <div className="min-w-0 flex-1 p-4" />
            </Layout>
        )
    }

    if (!page.campaign || !page.campaignId) {
        return <Navigate to="/" replace />
    }

    if (!page.allowed) {
        return <Navigate to={`/campaign/${page.campaignId}`} replace />
    }

    return (
        <Layout>
            {/* Main browse + sticky cart. Cart is a trailing column, not a nested grid of fields. */}
            <div className="lg:flex">
                <div className="min-w-0 flex-1 p-4">
                    <CampaignSummary
                        campaign={page.campaign}
                        company={page.client?.name}
                        companySector={page.client?.companySector}
                    />
                    <TalentBrowse
                        {...page.browse}
                        isLoading={page.talentLoading}
                        empty={({ search, filterCount }) => (
                            <div className="px-4 py-16 text-center italic">
                                {eligibilityHasConstraints(page.campaign?.eligibility) && filterCount > 0 && !search.trim()
                                    ? "No creators match these filters. Eligibility requirements are shown above — try widening Filters or switching lists."
                                    : "No creators match your filters."}
                            </div>
                        )}
                    />
                </div>
                {/* self-start so the rail does not stretch with the table; top-0 because the site nav scrolls away. */}
                <aside className="border-t border-border bg-white lg:sticky lg:top-0 lg:h-screen lg:w-80 lg:shrink-0 lg:self-start lg:overflow-auto lg:border-t-0 lg:border-l">
                    <PitchCart {...page.cart} />
                </aside>
            </div>
        </Layout>
    )
}
